module.exports = __webpack_public_path__ + "img/logo2.ba596cb1.png";